import { createSlice } from "@reduxjs/toolkit";

const VideoSlice = createSlice({
  name: "Video",
  initialState: {
    Products: []
  },
  reducers: {
    setVideo: (state, action) => {
      state.Videos = action.payload;
    },
  },
});

export const { 
  setVideo,
} = VideoSlice.actions;
export default VideoSlice.reducer;
